"use strict";

var _interopRequireDefault = require("/builds/frontend/web/agent/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/builds/frontend/web/agent/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/builds/frontend/web/agent/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/builds/frontend/web/agent/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.push.js");
var _vuex = require("vuex");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _index = require("@/utils/index");
var _index2 = require("@/lang/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "Navbar",
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default
  },
  props: {
    showHamburger: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isShow: !(0, _index.isFromWeiXin)(),
      defaultPic: require("../../assets/customer.png"),
      routeName: '',
      rightMenuWidth: 0
      // langs: {
      //   'ja': '日本語',
      //   'en': 'English'}
    };
  },
  // watch: {
  //   '$route': {
  //     deep: true,
  //     handler(route) {
  //       debugger
  //       const globalPath = ['/overseasList', '/overseasEdit'];
  //       this.langs = globalPath.includes(route.path) ? {'zh-CN': '中文', 'en': 'English' } : { 'ja': '日本語' };
  //     },
  //     immediate: true
  //   }
  // },
  watch: {
    '$route': {
      deep: true,
      handler: function handler(route) {
        this.routeName = route.name;
      },
      immediate: true
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["sidebar", "avatar", "device", "name", "domains", "language", "showClue", "isCustimerClue", "roles", "scope", "type"])), {}, {
    rightMenuStyle: function rightMenuStyle() {
      return {
        '--rightMenuWidth': this.rightMenuWidth + 'px'
      };
    } // displayedLang() {
    //   return this.langs[this.language];
    // },
  }),
  created: function created() {
    // this.langs = this.scope === 1 ? { 'ja': '日本語',} : {'en': 'English'}
    if (this.showClue && this.scope === 1) {
      this.$store.dispatch("user/getCustomerClue");
    }
  },
  mounted: function mounted() {
    this.rightMenuWidth = document.querySelector('.right-menu').offsetWidth;
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    // 切换语言
    // switchLang(targetLang) {
    //   if (targetLang !== this.language) {
    //     this.$store.dispatch("app/setLanguage", targetLang);
    //     loadLanguageAsync(targetLang).then(res => {
    //       this.$router.push(this.$route.path);
    //     })
    //   }
    // },
    closeChange: function closeChange(f) {
      this.$store.commit("user/SET_CUSTOMERCLUE", 0);
      this.$store.commit("user/SET_CLUE", 0);
      this.show = false;
      if (f) this.$router.push({
        path: "/clue",
        query: {
          from: true
        }
      });
    },
    // 退出登录
    logout: function logout() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("user/logout");
            case 2:
              _this.$router.push("/login");
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 完善中介信息
    perfectInfo: function perfectInfo() {
      this.$router.push("/perfectInfo");
    },
    // 更新密码
    updatePassword: function updatePassword() {
      this.$router.push("/updatedPassword");
    },
    close: function close() {
      this.visible = false;
    }
  }
};